import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  ModalFooter,
  Text,
  HStack,
  Tooltip,
  IconButton,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { addStateListAsync, deleteStateListAsync, fetchStateListAsync, selectState, selectStateTotal, updateStateListAsync } from "./StateListSlice";

function StateList() {
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const dispatch = useDispatch();
  const State = useSelector(selectState);
  // console.log("State", State)

  const totalCities = useSelector(selectStateTotal);

  const citiesPerPage = 15; // Number of jobs per page
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(totalCities / citiesPerPage);

  // Pagination handlers
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const [isLoading, setIsLoading] = useState(true);

  // Fetch jobs whenever the current page changes
  useEffect(() => {
    dispatch(fetchStateListAsync(currentPage))
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  }, [dispatch, currentPage]);

  const [newState, setnewState] = useState("");
  const [newStatus, setnewStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editState, seteditState] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editStatus, seteditStatus] = useState("");
  const [editableState, seteditableState] = useState(null);
  const [deletingState, setdeletingState] = useState(null);

  const handleDelete = async (uuid) => {
    await dispatch(deleteStateListAsync(uuid));
    dispatch(fetchStateListAsync(currentPage));
    onClose2();
  };

  const openDeleteModal = (job) => {
    setdeletingState(job);
    dispatch(fetchStateListAsync(currentPage));

    onOpen2();
  };

  const handleSave = async () => {
    const StateData = {
      title: newState,
      status: newStatus, // Get status from input
    };

    try {
      // console.log("New Job Title Component:", StateData);
      await dispatch(addStateListAsync(StateData));

      dispatch(fetchStateListAsync(currentPage));
      setnewState(""); // Clear input field after saving
      setnewStatus(""); // Clear status field
      onClose1();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = (StateData) => {
    seteditableState(StateData);
    seteditState(StateData.title);
    seteditStatus(StateData.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editState.trim()) {
      try {
        await dispatch(
          updateStateListAsync({
            uuid: editableState.uuid,
            StateData: {
              title: editState,
              status: editStatus, // Include status
            },
          })
        );

        dispatch(fetchStateListAsync(currentPage));
        seteditableState(null);
        seteditState("");
        seteditStatus(""); // Reset status
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div
      className="h-screen bg-adminbg contentAdmin p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    > 
      <div className=" pb-2">
        <div className="w-full my-5 bg-white rounded-xl">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              State List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add State
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        width="100%"
                      >
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>State</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter State"
                              value={newState}
                              onChange={(e) => setnewState(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>State Status</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter State Status"
                              value={newStatus}
                              onChange={(e) => setnewStatus(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleSave}>
                      Save
                    </Button>
                    <Button onClick={onClose1}>Cancel</Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit State
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <ModalBody py={6}>
                    <VStack spacing={6}>
                      <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        width="100%"
                      >
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>State</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter State"
                              value={editState}
                              onChange={(e) => seteditState(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem colSpan={2}>
                          <FormControl>
                            <FormLabel>State Status</FormLabel>
                            <Input
                              className=" "
                              color="black"
                              placeholder="Enter status"
                              value={editStatus}
                              onChange={(e) => seteditStatus(e.target.value)}
                            />
                          </FormControl>
                        </GridItem>
                      </Grid>
                      {error && <Text color="red.500">{error}</Text>}
                    </VStack>
                  </ModalBody>
                  <ModalFooter bg="gray.50" borderBottomRadius="md">
                    <Button colorScheme="blue" mr={3} onClick={handleUpdate}>
                      Update
                    </Button>
                    <Button onClick={() => setIsEditModalOpen(false)}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingState?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap="2" justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingState.uuid)}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outline"
                      colorScheme="red"
                      w="40"
                      onClick={onClose2}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">id</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action </Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(State) && State.length > 0 ? (
                  [...State]
                    .sort((a, b) => a.uuid - b.uuid)
                    .map((job, index) => (
                      <Tr key={job.uuid}>
                        <Td>{index + 1}</Td>
                        <Td>{job.name}</Td>
                        <Td textColor={"green"}>{job.status}</Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label="Edit State" placement="top">
                              <IconButton
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                                aria-label="Edit industry"
                              />
                            </Tooltip>
                            <Tooltip label="Delete State" placement="top">
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                                aria-label="Delete industry"
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr>
                    <Td colSpan="4" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
      {/* Pagination */}
      <GridItem colSpan={2} display="flex" justifyContent="center">
        <div className="flex w-full justify-evenly items-center mt-4">
          <button
            className={`bg-gray-300 text-black px-4 py-2 rounded ${
              currentPage === 1 ? "opaState-50 cursor-not-allowed" : ""
            }`}
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            className={`bg-blue-500 text-white px-4 py-2 rounded ${
              currentPage === totalPages ? "opaState-50 cursor-not-allowed" : ""
            }`}
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </GridItem>
      </div>
        </div>
    </div>
  );
}

export default StateList;
